import { combineReducers } from "redux";
import { ITheme, mainTheme } from "../theme/theme";

export interface IRootState {
  theme: ITheme;
  drawerOpen: boolean;
}

// Reducers
const initialState: IRootState = {
  theme: mainTheme,
  drawerOpen: false,
};

const counterReducer = (
  state = initialState,
  action: {
    type: "DRAWER";
    payload: boolean;
  }
) => {
  switch (action.type) {
    case "DRAWER":
      return { ...state, drawerOpen: action.payload };
    default:
      return state;
  }
};

// Combine Reducers
const rootReducer = combineReducers({
  rootState: counterReducer,
  // Add other reducers here if you have more
});

export default rootReducer;
